import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagCostaRica-gesidalijia",
  "use": "icon-FlagCostaRica-gesidalijia-usage",
  "viewBox": "0 0 1706 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1706 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagCostaRica-gesidalijia\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1706.666667v1024H0z\" fill=\"#002B7F\" p-id=\"4745\" /><path d=\"M0 170.666667h1706.666667v682.666666H0z\" fill=\"#FFFFFF\" p-id=\"4746\" /><path d=\"M0 341.333333h1706.666667v341.333334H0z\" fill=\"#CE1126\" p-id=\"4747\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol